import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Placeholder for partner slice
const initialState = {
  profile: null,
  products: [],
  orders: [],
  analytics: {
    totalSales: 0,
    totalCommissions: 0,
    pendingPayouts: 0,
    bestSellingProducts: [],
  },
  inventory: [],
  payouts: [],
  loading: false,
  error: null,
};

const partnerSlice = createSlice({
  name: 'partner',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { clearError } = partnerSlice.actions;
export default partnerSlice.reducer;